export default "__VITE_ASSET__Df89pRO$__"